import axios from '@/libs/api.request'

// 获取订单统计数据
export const getOrderStatistics = (params) => {
  return axios.request({
    url: 'statistics/orders',
    method: 'post',
    data: params
  })
}

// 获取收入统计数据
export const getRevenueStatistics = (params) => {
  return axios.request({
    url: 'statistics/revenue',
    method: 'post',
    data: params
  })
}

// 获取用户统计数据
export const getUserStatistics = (params) => {
  return axios.request({
    url: 'statistics/users',
    method: 'post',
    data: params
  })
}

// 获取车辆统计数据
export const getCarStatistics = (params) => {
  return axios.request({
    url: 'statistics/cars',
    method: 'post',
    data: params
  })
}

// 获取商品统计数据
export const getGoodsStatistics = (params) => {
  return axios.request({
    url: 'statistics/goods',
    method: 'post',
    data: params
  })
}

// 获取综合统计概览
export const getStatisticsOverview = (params) => {
  return axios.request({
    url: 'statistics/overview',
    method: 'post',
    data: params
  })
}

// 导出统计报表
export const exportStatisticsReport = (params) => {
  return axios.request({
    url: 'statistics/export',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

